import client from '@/api/client';

export interface UserProfile {
  email: string;
  user_id: string | null;
  display_name: string;
  initials: string;
  avatar_color: string;
}

export interface UserSettings {
  theme: 'dark' | 'light' | 'system';
  email_notifications: boolean;
  weekly_summary: boolean;
  product_updates: boolean;
  auto_refresh_dashboard: boolean;
}

export interface UpdateUserSettingsPayload {
  theme?: UserSettings['theme'];
  email_notifications?: boolean;
  weekly_summary?: boolean;
  product_updates?: boolean;
  auto_refresh_dashboard?: boolean;
}

export interface LogoutResponse {
  message: string;
  logout_url: string;
  global_logout_url?: string | null;
}

export const fetchUserProfile = async () => {
  const { data } = await client.get<UserProfile>('/user/me');
  return data;
};

export const fetchUserSettings = async () => {
  const { data } = await client.get<UserSettings>('/user/settings');
  return data;
};

export const updateUserSettings = async (payload: UpdateUserSettingsPayload) => {
  const { data } = await client.patch<UserSettings>('/user/settings', payload);
  return data;
};

export const requestLogout = async () => {
  const { data } = await client.post<LogoutResponse>('/user/logout');
  return data;
};

// Access request types and API
export type RequestedRole =
  | 'planner'
  | 'creative_agency'
  | 'activation'
  | 'approver'
  | 'viewer'
  | 'asset_manager';

export interface AccessRequestPayload {
  requested_role: RequestedRole;
  department?: string;
  message?: string;
}

export interface AccessRequestResponse {
  success: boolean;
  message: string;
}

export const submitAccessRequest = async (payload: AccessRequestPayload) => {
  const { data } = await client.post<AccessRequestResponse>('/user/request-access', payload);
  return data;
};
